export default "__VITE_ASSET__Nt4wffzX__"